import CreateVacancyContainer from "../containers/CreateVacancyContainer";

const CreateVacancyPage = () => {
  return (
    <CreateVacancyContainer />
  );
};

export default CreateVacancyPage;
